<template>
  <dl class="key-value-list" :class="keyValueClasses">
    <slot></slot>
  </dl>
</template>

<script>
import { ref } from 'vue';
export default {
  props: {
    variant: {
      type: String,
      required: false,
      default: 'list',
      validator(value) {
        return ['list', 'list-stacked', 'list-inline', 'grid'].includes(value);
      }
    },
    size: {
      type: String,
      required: false,
      default: 'regular',
      validator(value) {
        return ['regular', 'small'].includes(value);
      }
    },
    isDivided: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const keyValueClasses = ref({
      'key-value-list--variant-list-stacked': ['list-stacked', 'list'].includes(props.variant),
      'key-value-list--variant-list-inline': props.variant === 'list-inline',
      'key-value-list--variant-grid': props.variant === 'grid',
      'key-value-list--size-regular': props.size === 'regular',
      'key-value-list--size-small': props.size === 'small',
      'key-value-list--divided': props.isDivided
    });

    return {
      keyValueClasses
    };
  }
};
</script>

<style lang="scss">
.key-value-list {
  .key-value {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 0;

    dt {
      @extend .typography-body-sm-bold;
      color: $color-text-secondary;
      font-size: var(--key-value-label-font-size) !important;
    }

    dd {
      @extend .typography-body-md;
      color: $color-text-primary;
      font-size: var(--key-value-value-font-size) !important;
    }
  }

  &--variant-list-stacked,
  &--variant-list-inline {
    display: flex;
    flex-direction: column;
    gap: $spacing-4;
  }

  /**
     * Divided styles: Apply ONLY when divided is used alongside list variants.
     */
  &--divided[class*='--variant-list-'] {
    > :not(:last-child, :only-child) {
      border-bottom: 1px solid $color-line-border;
      padding-bottom: $spacing-3;
    }
  }

  &--variant-list-inline {
    .key-value {
      flex-flow: row wrap;
      align-items: center;
      gap: $spacing-2;
      padding: $spacing-1 0;
    }
  }

  &--variant-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); // keeping this as a fallback for now
    grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
    gap: $spacing-3;
    width: 100%;

    .key-value {
      padding: $spacing-1 0;
    }
  }

  &--size-small {
    --key-value-label-font-size: 12px; /* check with design */
    --key-value-value-font-size: 14px; /* check with design */
  }

  &--size-regular {
    --key-value-label-font-size: 14px; /* check with design */
    --key-value-value-font-size: 16px; /* check with design */
  }
}
</style>
